<template>
  <div>
    <div class="title-name"><b v-if="isneed" class="red">*</b>{{label}} <span class="el-upload__tip"> <b class="red" v-if="tip">#</b>{{tip}}</span></div>
    <div v-if="videoUrl&&videoUrl.src!==''">
      <div class="videos">
        <i class="el-icon-error remove-video" @click="handleRemove" />
        <div class="video-box">
          <video class="video" :src="videoUrl.src" />
          <div v-if="videoUrl.cover" class="poster">
            <img :src="videoUrl.cover">
          </div>
          <div class="action">
            <i class="el-icon-video-play" @click="visible=true" />
            <div class="df poster-action">
              <el-upload
                :show-file-list="false"
                action="/api_file/upload.do/oss/upload"
                :data="uploadConfig"
                accept="image/*"
                :on-success="onSubmitPoster"
              >
                <p class="action-btn">上传封面</p>
              </el-upload>
              <p class="action-btn" style="cursor:pointer" @click="deletePoster">删除封面</p>
            </div>

          </div>
        </div>
      </div>
      <div>
        <el-input v-if="textShow"
          v-model="videoUrl.text"
          type="textarea"
          rows="2"
          :style="textStyle"
          placeholder="视频备注"
        />
      </div>
    </div>
    <el-progress v-if="loading" type="circle" :percentage="loadProgress" style="margin-top:30px;"></el-progress>
    <el-upload
      v-if="!videoUrl.src && !loading"
      :show-file-list="false"
      action="/api_file/upload.do/oss/upload"
      :accept="acceptType"
      list-type="picture-card"
      :data="uploadConfig"
      :on-progress="beforeAvatarUpload"
      :before-upload="beforeUploadVideo"
      :on-success="onSubmit"
    >
      <i class="el-icon-plus" />
    </el-upload>
    <el-dialog :visible="visible" :before-close="handelCancel">
      <div v-if="videoUrl&&videoUrl.src!==''">
        <video
          :src="videoUrl.src"
          muted
          loop
          style="display: block;width: 100%;max-height: 480px;height: 100%"
          controls
          autoplay="autoplay"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'VideoUpload',
  componentName: 'VideoUpload',
  props: {
    acceptType: {
      type: String,
      default: 'audio/*,video/*'
    },
    textStyle:{
      default(){
        return{
          width:'148px',
          marginTop:'8px'
        }
      }

    },
    code: {
      type: String,
      default: 'cms/video/'
    },
    textShow: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    isneed:{
      default: false
    },
    videoUrl: {
      type: Object,
      default: () => {
        return {
          src: '',
          cover: '',
          text: ''
        }
      }
    },
    sizeLimit: {
      type: Number,
      default: 100
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      loadProgress: 0,
    }
  },
  computed: {
    uploadConfig() {
      return { code: this.code }
    }
  },
  methods: {
    beforeAvatarUpload(event, file, fileList){
      this.loadProgress = Math.floor(event.percent) //这就是当前上传的进度
      //可以进行其他逻辑
    },
    // 提交
    onSubmit(response, file, fileList) {
      this.loading = false
      this.$emit('update:videoUrl', Object.assign({}, this.videoUrl, { src: response.ossUrl || '' }))
    },
    onSubmitPoster(response, file, fileList) {
      console.log(response.ossUrl,'----')
      response.ossUrl?this.$set(this.videoUrl,'cover',response.ossUrl):''
    },
    handelCancel() {
      this.visible = false
    },
    // 移除视频
    handleRemove() {
      this.$emit('update:videoUrl', { src: '', cover: '', text: '' })
    },
    deletePoster() {
      this.videoUrl.cover = ''
    },
    // 上传视频前校验
    beforeUploadVideo(file) {
      console.log(this.videoUrl,"this.videoUrl")
      const { sizeLimit } = this
      this.loading = true
      console.info(`上传限制 : ${sizeLimit} MB`)
      console.log(this.acceptType)
      if (this.acceptType !== 'audio/*,video/*' && file.type !== this.acceptType) {
        this.$message.error(`只能上传 : ${this.acceptType} 格式!`)
        // this.videoUrl = {}
        this.loading = false
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < sizeLimit
      if (!isLt2M) {
        this.$message.error(`上传视频大小不能超过 ${sizeLimit} MB!`)
      }
      return isLt2M
    }
  }
}
</script>
<style lang="scss">
  .action {
    .el-upload:focus {
      border-color: transparent;
      color: inherit;
    }
  }

</style>
<style lang="scss" scoped>
  .tip {
    color: #A7AABD;
    font-size: 13px;
  }

  .upload-preview {
    flex-wrap: wrap;
  }

  .videos {
    margin: 0 10px 10px 0;
    position: relative;
    width: 148px;
  }

  .video-box {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    position: relative;

    .video {
      width: 100%;
      height: 100%;
      object-fit: cover
    }
  }

  .remove-video {
    position: absolute;
    right: -9px;
    top: -9px;
    font-size: 20px;
    cursor: pointer;
    color: #000;
    z-index: 3;
  }

  .action {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    background: rgba(0, 0, 0, .3);
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    opacity: 0;
    transition: opacity .5s;

    .el-icon-video-play {
      font-size: 40px;
      cursor: pointer;
    }

    &:hover {
      opacity: 1;
    }
  }

  .poster-action {
    position: absolute;
    bottom: 10px;
    // right: 0;
    .action-btn {
      margin: 0 8px;
    }
  }

  .poster {
    width: 100%;
    height: 100%;
    position: absolute;
    background: #fff;
    top: 0;
    left: 0;

    > img {
      width: 100%;
      height: 100%;
    }
  }
</style>
